import { _numberEnumValues } from '@naturalcycles/js-lib';
export var LoginProvider = /*#__PURE__*/function (LoginProvider) {
  LoginProvider[LoginProvider["APPLE"] = 1] = "APPLE";
  LoginProvider[LoginProvider["GOOGLE"] = 2] = "GOOGLE";
  LoginProvider[LoginProvider["EMAIL"] = 3] = "EMAIL";
  return LoginProvider;
}(LoginProvider || {});
export var RegistrationFlow = /*#__PURE__*/function (RegistrationFlow) {
  RegistrationFlow[RegistrationFlow["OURA"] = 1] = "OURA";
  RegistrationFlow[RegistrationFlow["APPLE_WATCH"] = 2] = "APPLE_WATCH";
  RegistrationFlow[RegistrationFlow["META_LANDING_PAGE"] = 3] = "META_LANDING_PAGE";
  RegistrationFlow[RegistrationFlow["PAYMENT_REDIRECT_FROM_APP"] = 4] = "PAYMENT_REDIRECT_FROM_APP";
  return RegistrationFlow;
}(RegistrationFlow || {});
export var SessionScope = /*#__PURE__*/function (SessionScope) {
  SessionScope[SessionScope["APP"] = 1] = "APP";
  SessionScope[SessionScope["WEBSIGNUP_OR_MANAGE_ACCOUNT"] = 2] = "WEBSIGNUP_OR_MANAGE_ACCOUNT";
  SessionScope[SessionScope["PARTNER"] = 3] = "PARTNER";
  return SessionScope;
}(SessionScope || {});
export const ALL_SCOPES = _numberEnumValues(SessionScope);